import { render, staticRenderFns } from "./control-table.vue?vue&type=template&id=2e1f7dab&scoped=true"
import script from "./control-table.vue?vue&type=script&lang=js"
export * from "./control-table.vue?vue&type=script&lang=js"
import style0 from "./control-table.vue?vue&type=style&index=0&id=2e1f7dab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1f7dab",
  null
  
)

export default component.exports